(function($) {

	'use strict';

	function init(){
		if( glossary && Object.keys(glossary).length > 0 ){
			// Liste des balises qu'on souhaite ignorer
			const excludeElements = ['script', 'style', 'iframe', 'canvas', 'a', 'link', 'form'];
	
			// Construction de la regex avec tous les mots
			let wordsRegex = "";
			for( let word in glossary ){
				wordsRegex += (wordsRegex?"|":"")+word;
			}
			const regex_str = "(?:[^À-ú]|^)\\b("+wordsRegex+")\\b(?:[^À-ú]|$)";
			const regex = new RegExp(regex_str,"ig");
			
			// Récupération de toutes les balises dans <main>
			const main = document.querySelector('main:not(.glossary)');
			if( main ){
				matchText(main, regex, excludeElements);
			}
		}
	};

	//cf. https://stackoverflow.com/questions/16662393/insert-html-into-text-node-with-javascript
	function matchText(node, regex, excludeElements){
		let child = node.firstChild;

		// Boucle tant que child contient un élément
		while(child){

			// Liste des nodeType : https://developer.mozilla.org/fr/docs/Web/API/Node/nodeType
			switch( child.nodeType ){
				case 1 :
					// Vérification si l'élément actuel est un élément que l'on veut exclure, auquel cas on passe à la boucle suivante
					if( excludeElements.indexOf(child.tagName.toLowerCase()) > -1 ){
						break;
					} else {
						// Si l'élément n'est pas exclus, on relance une vérification parmis ses enfants
						matchText(child, regex, excludeElements);
					}
					break;

				case 3 : // Noeud de type texte, on va appliquer la regex
					// On ne traite pas les noeud texte vides
					if(child.data.trim().length !== 0){
						let offsetFix = 0;

						child.data.replace(regex, function(match, p1) {
							// Récupération de tous les arguments de la fonction anonyme passée en 2eme paramètre de replace()
							// Array().slice.call pour récupérer un tableau d'arguments sans avoir toutes les propriétés de l'objet Arguments
							// cf. https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/String/replace#indiquer_une_fonction_comme_param%C3%A8tre
							let args = Array().slice.call(arguments);

							// Récupération du mot identifié par la regex
							let word = args[1];
	
							// Récupération du offset
							// /!\ Attention, cet offset a été calculé par la fonction replace() qui a été éxécutée une
							// seule fois sur le noeud d'origine. La valeur offset va donc être relative à la longueur
							// du texte d'origine. La variable offsetFix calculée plus bas permet de corriger ce problème
							let offset = args[args.length - 2] + ( args[args.length - 2] > 0 ? 1 : 0 ) ;
							
							// Split du noeud à la position de la chaine de caractère que l'on veut remplacer
							// +offsetFix => Valeur négative calculée lors de la précédente itération de la regex. 
							let newTextNode = child.splitText(offset+offsetFix);

							// Suppression du mot recherché dans le 2e noeud après le split précédent
							newTextNode.data = newTextNode.data.substr(word.length);
	
							// Calcul du offsetFix pour la prochaine itération de cette fonction
							offsetFix -= child.data.length + p1.length;
	
	
							// Création du noeud <span> pour ajouter le tooltip autour du mot recherché
							let glossaryWordItem = document.createElement("span");
							glossaryWordItem.className = "glossaryTooltipWord";
							glossaryWordItem.textContent = args[1];
							glossaryWordItem.addEventListener("mouseover", position_tooltip);

							// Création du noeud <span> contenant la définition
							let glossaryDefItem = document.createElement("span");
							glossaryDefItem.className = "glossaryTooltipDef";
							let glossaryDef = glossary[Object.keys(glossary).find(key => key.toLowerCase() === word.toLowerCase())];
							glossaryDefItem.textContent = glossaryDef;
							
							// Insertion du tooltip
							glossaryWordItem.appendChild(glossaryDefItem);
							child.parentNode.insertBefore(glossaryWordItem, newTextNode);
	
							// Remplace la variable child par le nouveau noeud, créé lors du split
							// Permet à ce que le prochain appel de cette fonction anonyme se base sur la fin de la chaine
							// car le noeud original n'existe plus depuis son split
							child = newTextNode;
						});
					}
					regex.lastIndex = 0;
					break;
			}

			// On passe au prochain élément pour la boucle while
			child = child.nextSibling;
		}
	}

	function position_tooltip(e){
		// Get tooltip item
		const tooltip = this;
		const def = tooltip.querySelector('.glossaryTooltipDef');

		if( def ){
			const bound = tooltip.getBoundingClientRect();
			const overflowRight = ( (bound.x + bound.width + 10 + 100) > window.innerWidth );
			const overflowLeft = ( (bound.x - 10 - 100) < 0 );
			if( !overflowLeft && overflowRight ){ // Overflow right only
				def.classList.add('glossaryTooltipDef--left');
			} else if( overflowLeft && !overflowRight ){ // Overflow left only
				def.classList.add('glossaryTooltipDef--right');
			} else {
				def.classList.remove('glossaryTooltipDef--left');
				def.classList.remove('glossaryTooltipDef--right');
			}
		}
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
